import React from 'react'
import { Form } from 'react-bootstrap'
import Select from 'react-select'

export default function SingleSelect(props) {

    const { label_name, placeholder, disabled, closeMenu,isClearable, option, name, defaultValue,required, onInputChange,onChange, onBlur, error, loading, reference } = props

    return (
        <>
            <Form.Group className="mb-3" controlId="">
                {label_name == '' ? '' : <Form.Label className='form_label'>{label_name}{required == true ? <span className='required_filed'>*</span>:""}</Form.Label>}
                <Select
                    ref={reference}
                    closeMenuOnSelect={closeMenu}
                    placeholder={placeholder}
                    isDisabled={disabled}
                    options={option}
                    isClearable={isClearable}
                    className='react_select'
                    classNamePrefix="select"
                    name={name}
                    defaultValue={defaultValue}
                    onChange={onChange}
                    onInputChange={onInputChange}
                    onBlur={onBlur}
                    isLoading={loading}
                />
                {error}
            </Form.Group>
        </>
    )
}
